import { dec, type Dec } from '@praticheenergia/ad1-engine'
import { formattaKwh } from '../dichiarazione/riepilogo'

export const MESI = ['gen', 'feb', 'mar', 'apr', 'mag', 'giu', 'lug', 'ago', 'set', 'ott', 'nov', 'dic']

export const etichettaMese = (anno: number, mese: number) => `${MESI[mese - 1]} ${anno}`

/** Da una data ISO (`2026-09-01`) all'etichetta del mese. */
export function meseDaData(data: string | null): string {
  if (!data) return '—'
  const [anno, mese] = data.split('-').map(Number)
  return etichettaMese(anno!, mese!)
}

export const kwh = (v: string | Dec | null) => (v === null ? '—' : formattaKwh(dec(v)))

export function percento(v: Dec | null): string {
  if (v === null) return '—'
  const s = v.toFixed(1).replace('.', ',')
  return v.greaterThan(0) ? `+${s}%` : `${s}%`
}
